import { createFileRoute } from "@tanstack/react-router";
import { MainLayout } from "@/components/layout/MainLayout";
import { CreditReceipts } from "@/components/credits/CreditReceipts";
import { Button } from "@/components/ui/button";
import { Link } from "@/lib/router-compat";
import { useAuth } from "@/hooks/useAuth";
import { authPath } from "@/lib/authRedirect";
import { uiText } from "@/lib/i18n/uiText";

export const Route = createFileRoute("/credit-receipts")({
  head: () => ({ meta: [
    { title: "Credit receipts | Statlign" },
    { name: "description", content: "Your Statlign credit receipts, prediction reveals and analysis purchases." },
    { property: "og:title", content: "Credit receipts | Statlign" },
    { property: "og:description", content: "Your Statlign credit receipts, prediction reveals and analysis purchases." },
    { property: "og:type", content: "website" },
    { name: "twitter:card", content: "summary" },
    { name: "robots", content: "noindex, nofollow" },
  ] }),
  component: CreditReceiptsPage,
});

function CreditReceiptsPage() {
  const { user, isLoading } = useAuth();
  return <MainLayout>
    <div className="mx-auto max-w-3xl space-y-4 p-4 py-8">
      <h1 className="text-2xl font-bold">{uiText("Credit receipts")}</h1>
      {!isLoading && (user ? <CreditReceipts limit={Infinity} /> :
        <Button asChild><Link to={authPath("/credit-receipts")}>{uiText("Sign in")}</Link></Button>)}
    </div>
  </MainLayout>;
}